import type { SessionProvider, Session } from './types'

export class LocalStorageSessionProvider implements SessionProvider {
  constructor(private storageKey: string) {}

  getSession(): Session | null {
    if (typeof window === 'undefined') return null
    try {
      return JSON.parse(window.localStorage.getItem(this.storageKey))
    } catch {
      return null
    }
  }

  getUserData() {
    const session = this.getSession()
    return {
      user_id: session?.user?.id,
      user_email: session?.user?.email,
    }
  }
}

export class NoopSessionProvider implements SessionProvider {
  getSession() {
    return null
  }

  getUserData() {
    return {}
  }
}
